module.exports = __webpack_public_path__ + "img/menuicon-104-active.b0368b62.png";